import React from "react";

const ServiceSection = () => {
  const serviceCard = [
    {
      img: "fa fa-user",
      title: "NFT Consultant Analytics",
      content:
        "Once You have Set Up Your Wallet Of Choice, Connect It To OpenSeaby Clicking The NFT Marketplacein The Top Right Corner.",
    },
    {
      img: "fa fa-message",
      title: "NFT Marketing",
      content:
        "Once You have Set Up Your Wallet Of Choice, Connect It To OpenSeaby Clicking The NFT Marketplacein The Top Right Corner.",
    },
    {
      img: "fa-solid fa-gears",
      title: "NFT Strategy",
      content:
        "Once You have Set Up Your Wallet Of Choice, Connect It To OpenSeaby Clicking The NFT Marketplacein The Top Right Corner.",
    },
    {
      img: "fa-solid fa-database",
      title: "NFT Technology",
      content:
        "Once You have Set Up Your Wallet Of Choice, Connect It To OpenSeaby Clicking The NFT Marketplacein The Top Right Corner.",
    },
    {
      img: "fa-regular fa-newspaper",
      title: "Advisers & Intermediaries",
      content:
        "Once You have Set Up Your Wallet Of Choice, Connect It To OpenSeaby Clicking The NFT Marketplacein The Top Right Corner.",
    },
    {
      img: "fa-solid fa-key",
      title: "ICO Token",
      content:
        "Once You have Set Up Your Wallet Of Choice, Connect It To OpenSeaby Clicking The NFT Marketplacein The Top Right Corner.",
    },
  ];

  return (
    <div className="service-section section-padding " id="service" >
      <div className="container">
        <div className="row">
          <div className="col-md-6 mx-auto text-center service-title">
            <h2 className="text-white fw-bolder" data-aos='fade-up'  >Our Services</h2>
            <p className="my-4" data-aos='fade-up'  >
              Connect Our AI To Your Exchange Account And Invest Crypto
              Automatically. Xhibiter App Work While You Just Live.
            </p>
          </div>
        </div>

        {/* SERVICE CARD SECTION */}
        <div className="row g-md-5 g-4 mt-5">
            {
                serviceCard.map((element , index) => {
                    return (
                        <div key={index} className="col-lg-4 col-sm-6" data-aos='zoom-in'>
                            <div className="service-card">
                                <div className="service-card-icon mb-4">
                                    <i className={element.img}></i>
                                </div>
                                <h4 className="text-white mt-md-5 mt-4 mb-4">{element.title}</h4>
                                <p style={{textAlign: 'justify' , textAlignLast: 'left'}}>{element.content}</p>
                            </div>
                        </div>
                    )
                })
            }
        </div>

      </div>
    </div>
  );
};

export default ServiceSection;
